import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import WhyChooseSection from '../components/WhyChooseSection';
import ClinicPhotosSection from '../components/ClinicPhotosSection';
import ApproachSection from '../components/ApproachSection';
import TreatmentAreas from '../components/TreatmentAreas';

const Home: React.FC = () => {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <WhyChooseSection />
      <ClinicPhotosSection />
      <ApproachSection />
      <TreatmentAreas />
    </main>
  );
};

export default Home; 